<template>
  <div class="animated fadeIn" id="faturamento-competencia">
    <div class="card card-default">
      <div class="card-header">
        <i class="fa fa-money"></i> Lista de Faturamentos
      </div>
      <div class="card-body">
        <div class="input-group mb-3 d-flex align-items-center">
          <span class="input-group-text" id="profissional" style="width: 100">
            Competência
          </span>
          <date-picker
            input-class="form-control"
            v-model="competencia"
            lang="pt-br"
            format="MM/YYYY"
            style="height: calc(40% - 90px)"
          ></date-picker>
          <button
            class="btn btn-primary search-btn"
            @click="pesquisar"
            style="margin-left: 10px; height: 36px"
            :disabled="!competencia || isSearching"
          >
            <i v-if="isSearching" class="fa fa-spinner fa-spin"></i>
            <span v-else><i class="fa fa-search"></i> Pesquisar</span>
          </button>

          <button
            class="btn btn-primary search-btn"
            @click="geraFaturamento"
            style="margin-left: 10px; height: 36px"
            :disabled="!demandas.length || isGenerating"
          >
            <i v-if="isGenerating" class="fa fa-spinner fa-spin"></i>
            <span v-else><i class="fa fa-money"></i> Gerar Faturamento</span>
          </button>
        </div>

        <div v-if="demandas.length">
          <div class="header-horas">
            <span class="title-horas">Horas Faturadas</span>
          </div>
          <div class="horas-orcadas">
            <table id="table-orcadas" class="table table-striped table-sm">
              <thead>
                <tr>
                  <th>Sistema</th>
                  <th>Issue</th>
                  <th>Horas</th>
                  <th>CP</th>
                  <th>Origem</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="demanda in demandas"
                  :key="demanda.id"
                  :class="{ 'failure-row': isFailure(demanda.id) }"
                >
                  <td>{{ demanda.sistema }}</td>
                  <td>{{ demanda.title }}</td>
                  <td>{{ demanda.horas }}</td>
                  <td>{{ demanda.cp_funcional }}</td>
                  <td>{{ demanda.origem }}</td>
                </tr>

                <tr>
                  <td class="totais">Total AMS</td>
                  <td></td>
                  <td class="totais">{{ totalAMS }}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="totais">Total FSW</td>
                  <td></td>
                  <td class="totais">{{ totalFSW }}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="totais">Total Geral</td>
                  <td></td>
                  <td class="totais">{{ total }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <notifications group="faturamento-competencia" />
  </div>
</template>

<style lang="scss">
.input-group {
  display: flex;
  align-items: center;
}

.date-picker {
  flex-grow: 1;
}
.header-horas {
  flex-direction: row;
  justify-content: space-between;
  border-radius: 8px;
  padding: 12px;

  .title-horas {
    font-size: 22px;
    font-weight: bold;
  }
}
.totais {
  font-weight: bold;
}
.failure-row {
  background-color: #ffcccc !important;
  font-weight: bold !important;
}
</style>

<script>
import Uteis from "@/mixins/utils.js";
import DatePicker from "vue2-datepicker";

export default {
  components: { DatePicker },
  mixins: [Uteis],
  data() {
    return {
      competencia: null,
      demandas: [],
      total: 0,
      totalFSW: 0,
      totalAMS: 0,
      failures: [],
      isSearching: false,
      isGenerating: false,
    };
  },
  watch: {
    competencia() {
      this.demandas = [];
      this.failures = [];
    },
  },
  methods: {
    isFailure(demandaId) {
      return this.failures.includes(demandaId);
    },
    async pesquisar() {
      this.isSearching = true;
      const data = new Date(this.competencia);
      const mes = String(data.getMonth() + 1);
      const ano = data.getFullYear();

      const dto = { mes, ano };

      try {
        const { data: response } = await this.$http.get("/faturamento/horas", {
          params: dto,
        });

        this.demandas = response.registros.demandas;
        this.total = response.registros.total;
        this.totalFSW = response.registros.totalFSW;
        this.totalAMS = response.registros.totalAMS;
      } catch (error) {
        return error;
      } finally {
        this.isSearching = false;
      }
    },
    async geraFaturamento() {
      this.isGenerating = true;
      const data = new Date(this.competencia);
      const mes = String(data.getMonth() + 1);
      const ano = data.getFullYear();

      const dto = { mes, ano };
      try {
        const { data: response } = await this.$http.post(
          "/faturamento/faturar",
          dto
        );
        this.failures = response.failures.map((failure) => failure.issue_id);
        if (this.failures.length > 0) {
          return this.notificar(
            "Erro ao gerar o faturamento!",
            "faturamento-competencia",
            "error"
          );
        }
        this.notificar(
          "Faturamento gerado com sucesso!",
          "faturamento-competencia",
          "success"
        );
      } catch (error) {
        this.notificar(
          "Erro ao gerar o faturamento!",
          "faturamento-competencia",
          "error"
        );
        return error;
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>
